import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import StudentDetailComp from "./Component/StudentDetailComp"


const StudentDetail =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <StudentDetailComp />
        </div>
        <Footer />
        </>
    )
}

export default StudentDetail